import { HistoryEventParameters } from '@api/types';
import { getPartnerName } from '@react/constants/historyEvent/utils';

class PartnerNameUpdater {
  check(): boolean {
    return true;
  }

  updateParams(params: HistoryEventParameters): void {
    params.partnerName = getPartnerName({
      name: params.partner,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      partner_display_name: params.partner_display_name,
    });
  }
}

export const partnerNameUpdater = new PartnerNameUpdater();
